import { useOutletContext } from "react-router";

import TestSourceConnection from "../TestSourceConnection";

import ExistingSource from "@/types/sources";

type SourceConnectionDetailsProps = {
  source: ExistingSource;
};

const SourceConnectionDetails = () => {
  const { source } = useOutletContext<SourceConnectionDetailsProps>();
  return <TestSourceConnection key={source.id} existingSource={source} />;
};

export default SourceConnectionDetails;
